// Mantém a contagem de "Transferência de hotel pendente" atualizada no
// registro de notificações via polling leve -- mesmo raciocínio de
// useMeritPendingPoll.js (ticket #133 em taualegre-gameficacao-app-admin):
// GET .../hotel-transfer-requests/pending-count, só COUNT(*), + poll
// espaçado. Ver docs/adr/0001-sidebar-notification-indicator.md.
import { onMounted, onUnmounted } from 'vue'
import { countPendingHotelTransferRequests } from '@/services/hotelTransferService'
import { useAuthStore } from '@/stores/auth.store'
import { setNotificationCount, canSeeNotificationSource } from './registry'

const KEY      = 'transferencia-hotel-pendente'
const POLL_MS  = 150_000 // 2.5min

export function useHotelTransferPendingPoll() {
  let timer = null
  const auth = useAuthStore()

  async function fetchOnce() {
    if (document.hidden) return
    try {
      const { data } = await countPendingHotelTransferRequests()
      setNotificationCount(KEY, data.count)
    } catch {
      // Falha de rede não deve gerar erro visível por causa de um badge --
      // mantém a última contagem conhecida até o próximo poll funcionar.
    }
  }

  onMounted(() => {
    // Perfil sem acesso (ex.: Banqueiro) não consulta: o backend responderia 403 a cada ciclo.
    if (!canSeeNotificationSource(KEY, auth.role)) return
    fetchOnce()
    timer = setInterval(fetchOnce, POLL_MS)
  })

  onUnmounted(() => {
    if (timer) clearInterval(timer)
  })
}
